import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";
import { ApplicationStatusEnum } from "./job-application.dto";

export const UpdateJobApplicationSchema = z.object({
  companyName: z.string().min(1).max(200).optional(),
  jobTitle: z.string().min(1).max(200).optional(),
  jobDescription: z.string().optional(),
  jobUrl: z.string().url().optional().or(z.literal("")),
  coverLetterId: z.string().cuid().optional(),
  status: ApplicationStatusEnum.optional(),
  reminderEnabled: z.boolean().optional(),
  appliedAt: z.string().datetime().optional(),
  reminderDate: z.string().datetime().optional(),
  followUpDate: z.string().datetime().optional(),
  interviewDate: z.string().datetime().optional(),
  notes: z.string().optional(),
});

export class UpdateJobApplicationDto extends createZodDto(UpdateJobApplicationSchema) {}
